let itemsData = [{
  "sku_id": 1000271,
  "title": "远程控制器",
  "sub_title": "环保材质、耐磨、耐油、耐久性强",
  "ali_image": require('@/assets/img/item/902befd5f32a8caf4ca79b55d39ee25a.jpg'),
  "model": 'CG-box023-1',
  "ali_images": [
    {'image':require('@/assets/img/item/902befd5f32a8caf4ca79b55d39ee25a.jpg')},
    {'image':require('@/assets/img/item/ca760e50409c796a4e770c54554f92bf.jpg')},
    {'image':require('@/assets/img/item/493c65d42fe83ec3daaf058d79fc1a95.jpg')},
    {'image':require('@/assets/img/item/0bf30081dd17431c4fdfbd237c53743f.jpg')},
    {'image':require('@/assets/img/item/cba7b4cdb2fc41d7f29fb45d94972e41.jpg')},
  ],
  'tech':[
    '采用3.7V锂电池供电，开锁电流小于120mA',
    '锌合金外壳，锌合金锁芯',
    '工作温度－30℃—70℃',
    '工作湿度 95%RH'
  ],
  'detail':'此两种型号无源锁用于光缆交接箱，均采用无源锁芯，锁体安装尺寸与光缆交接箱机械锁体完全兼容，安装时无需改变箱体开孔尺寸。具有唯一32位ＩＤ编码，采用电子钥匙外部供电，有记录开锁电子钥匙ID和时间功能。KS0184-1型号无源锁为三点锁紧，KS0184-2型号无源锁为单点锁紧。'
  ,'pdf_url':'led.pdf'
},{
  "sku_id": 1000299,
  "title": "Smartisan 快充移动电源 10000mAh",
  "sub_title": "10000mAh 双向快充、轻盈便携、高标准安全保护",
  "ali_image": "http://image.smartisanos.cn/resource/ae40a16324658c192c7361d829f603bd.jpg",
  "model": 'CG023-2',
  "ali_images": [
    "http://image.smartisanos.cn/resource/ae40a16324658c192c7361d829f603bd.jpg",
    "http://image.smartisanos.cn/resource/0540778097a009364f2dcbb8c5286451.jpg",
    "http://image.smartisanos.cn/resource/ed7ea75824124d7385c99d532f1d4f1d.jpg",
    "http://image.smartisanos.cn/resource/40b8c1b1e5d175cc8fa9e7ff96cb6016.jpg",
    "http://image.smartisanos.cn/resource/fb24dc3db26c6f02542e0dea9b10151b.jpg"
  ],
}]

export default itemsData



// WEBPACK FOOTER //
// ./src/lib/controllersDetailData.js